import { useState } from 'react';
import Button from '../../../components/base/Button';
import Input from '../../../components/base/Input';

export default function HeroSection() {
  const [ville, setVille] = useState('');
  const [codePostal, setCodePostal] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!ville.trim() && !codePostal.trim()) {
      alert('Veuillez renseigner au moins une ville ou un code postal');
      return;
    }

    // Construire la recherche de localisation
    const locationSearch = ville.trim() || codePostal.trim();
    
    // Rediriger vers la page des coachs avec le filtre de localisation
    window.REACT_APP_NAVIGATE(`/coachs?location=${encodeURIComponent(locationSearch)}`);
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/3b1f41d85bf9a8b4105bcbfd0da69b76.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Trouvez votre coach sportif idéal à domicile
          </h1>
          <p className="text-xl md:text-2xl mb-4 text-gray-100">
            CoachFit connecte les passionnés de fitness avec des coachs certifiés qui viennent chez vous
          </p>
          <p className="text-lg mb-8 text-gray-200">
            Plus de 500 coachs professionnels disponibles dans toute la France pour vous accompagner dans l'atteinte de vos objectifs : perte de poids, prise de masse, remise en forme, préparation sportive ou bien-être général
          </p>
          
          <form 
            onSubmit={handleSubmit}
            className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 max-w-2xl mx-auto shadow-2xl"
          >
            <h3 className="text-2xl font-semibold text-gray-800 mb-6">
              Commencez votre recherche
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <Input
                type="text"
                placeholder="Votre ville"
                value={ville}
                onChange={(e) => setVille(e.target.value)}
                className="text-gray-800"
              />
              <Input
                type="text"
                placeholder="Code postal"
                value={codePostal}
                onChange={(e) => setCodePostal(e.target.value)}
                className="text-gray-800"
              />
            </div>
            <Button 
              type="submit"
              size="lg" 
              className="w-full md:w-auto px-8"
            >
              <i className="ri-search-line mr-2"></i>
              Trouver mon coach
            </Button>
          </form>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-user-star-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Coachs certifiés</h3>
              <p className="text-gray-200">Plus de 500 coachs professionnels vérifiés</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-home-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">À domicile</h3>
              <p className="text-gray-200">Entraînement dans le confort de votre foyer</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-calendar-check-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Flexible</h3>
              <p className="text-gray-200">Réservation selon vos disponibilités</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}